<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import ContactLeadForm from './ContactLeadForm.vue'
import type { ContactBlock, WebsiteLeadCaptureState, WebsiteLeadSubmission } from '../../types'

defineProps<{ block: ContactBlock; leadCapture?: WebsiteLeadCaptureState }>()
const emit = defineEmits<{ leadSubmit: [submission: WebsiteLeadSubmission] }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container site:grid site:overflow-hidden site:border site:border-(--site-color-border) site:bg-(--site-color-surface) site:shadow-(--site-shadow-md) site:@min-[64rem]:grid-cols-[1.1fr_0.9fr]" :style="{ borderRadius: 'var(--site-radius-lg)' }">
      <div class="site:p-7 site:@min-[40rem]:p-12 site:@min-[64rem]:p-16">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
        <ContactLeadForm v-if="leadCapture?.enabled" :lead-capture="leadCapture" @submit="emit('leadSubmit', $event)" />
        <SiteLink v-else-if="block.content.primaryAction" :link="block.content.primaryAction" class="site-site-button site:mt-8">
          {{ block.content.primaryAction.label }}
        </SiteLink>
      </div>

      <div class="site:bg-(--site-color-primary) site:p-7 site:text-(--site-color-primary-text) site:@min-[40rem]:p-10 site:@min-[64rem]:p-12">
        <div class="site:grid site:gap-7">
          <div v-for="method in block.content.methods" :key="method.id">
            <SiteEditableText v-model="method.label" as="p" class="site:text-xs site:font-bold site:tracking-wider site:uppercase site:opacity-90" />
            <SiteLink :link="method.link" class="site-heading site:mt-2 site:inline-block site:text-xl site:font-bold">{{ method.link.label }}</SiteLink>
          </div>
          <div v-if="block.content.hours">
            <p class="site:text-xs site:font-bold site:tracking-wider site:uppercase site:opacity-90">Hours</p>
            <SiteEditableText v-model="block.content.hours" as="p" class="site-heading site:mt-2 site:text-xl site:font-bold" />
          </div>
          <div v-if="block.content.address">
            <p class="site:text-xs site:font-bold site:tracking-wider site:uppercase site:opacity-90">Service area</p>
            <SiteEditableText v-model="block.content.address" as="p" class="site-heading site:mt-2 site:text-xl site:font-bold" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
